import React from 'react';
import { Label, Segment } from 'semantic-ui-react';
import EmailIcon from '@/components/EmailIcon';

const TaskRequestFormInfo = ({ assignee, groups }) => (
  <Segment className="aridhia-task-request-info">
    {(groups.length > 0) && (
      <Label.Group size="large">
        {groups.map((value) => (<Label icon="users" key={value.id} content={value.name} />))}
      </Label.Group>
    )}
    {(assignee) && (
      <EmailIcon className="aridhia-task-request-assignee" email={assignee.email} name={assignee.name} />
    )}
  </Segment>
);

export default TaskRequestFormInfo;
